export default {
  update: { method: "put", url: "services/update" },
};
